import { render, staticRenderFns } from "./Lms.vue?vue&type=template&id=164a4869&scoped=true&"
import script from "./Lms.vue?vue&type=script&lang=js&"
export * from "./Lms.vue?vue&type=script&lang=js&"
import style0 from "./Lms.vue?vue&type=style&index=0&id=164a4869&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a4869",
  null
  
)

export default component.exports